import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import trend from '@/components/trend'
import performance from '@/components/performance'
import appear from '@/components/appear'
import strategy from '@/components/strategy'
import scheme from '@/components/scheme'
import product from '@/components/product'

import menu from '@/components/menu'
import comhead from '@/components/comhead'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      name: 'index'
    },
    {
      path: '/menu',
      name: 'menu',
      component: menu,
      name: 'menu',
      children: [
        { path: '/menu/comhead',name: 'comhead',component: comhead},
        { path: '/menu/trend',name: 'trend',component: trend},
        { path: '/menu/performance',name: 'performance',component: performance},
        { path: '/menu/appear',name: 'appear',component: appear},
        { path: '/menu/strategy',name: 'strategy',component: strategy},
        { path: '/menu/scheme',name: 'scheme',component: scheme},
        { path: '/menu/product',name: 'product',component: product},
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js